// Admin type scale shared by the Collab Club and Publishing admin pages
// (matches the app's subtext / tiny / labelSmall).
export const FONT = {
  lg: 18, // primary emphasis — artist / match / target names
  base: 16, // body — table data, header labels, pagination
  sm: 14, // secondary — meta lines, badges, chips, sort pills
} as const;
